import React, { useState } from "react";

export const Tooltip = ({ content, closeText, onClose }) => {
  const handleClose = () => {
    onClose && onClose();
  };

  return (
    <div className="bg-white text-gray-800 p-6 rounded-lg shadow-lg max-w-xs border border-gray-200 relative before:content-[''] before:absolute before:-left-2.5 before:top-[9%] before:w-0 before:h-0 before:border-t-[10px] before:border-b-[10px] before:border-r-[10px] before:border-t-transparent before:border-b-transparent before:border-r-gray-200">
      <div className="absolute -left-2 top-[9%] w-0 h-0 border-t-8 border-b-8 border-r-8 border-t-transparent border-b-transparent border-r-white"></div>
      {content}
      <button
        className="text-xs text-primary font-semibold py-2 px-4 rounded transition-colors duration-200 border border-solid border-gray-200 hover:bg-primary-50 hover:border-primary-400"
        onClick={handleClose}
      >
        {closeText}
      </button>
    </div>
  );
};

export default Tooltip;
